import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadSenderRecipientsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadSenderRecipientsQuery = (
  { __typename?: 'Query' }
  & { senderRecipients: Array<(
    { __typename?: 'SenderRecipient' }
    & Pick<Types.SenderRecipient, '_id' | '_deleted' | 'supplierNumber' | 'countryCode' | 'name' | 'place' | 'postCode' | 'street' | 'phone' | 'inactive'>
  )> }
);

export type CreateSenderRecipientMutationVariables = {
  input?: Types.Maybe<Types.SenderRecipientInsertType>
};


export type CreateSenderRecipientMutation = (
  { __typename?: 'Mutation' }
  & { createSenderRecipient: (
    { __typename?: 'SenderRecipient' }
    & Pick<Types.SenderRecipient, '_id'>
  ) }
);

export type UpdateSenderRecipientMutationVariables = {
  id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.SenderRecipientSetType>
};


export type UpdateSenderRecipientMutation = (
  { __typename?: 'Mutation' }
  & { updateSenderRecipient: Array<(
    { __typename?: 'SenderRecipient' }
    & Pick<Types.SenderRecipient, '_id'>
  )> }
);

export type DeleteSenderRecipientMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteSenderRecipientMutation = (
  { __typename?: 'Mutation' }
  & { deleteSenderRecipient: Array<(
    { __typename?: 'SenderRecipient' }
    & Pick<Types.SenderRecipient, '_deleted'>
  )> }
);

export const ReadSenderRecipientsDocument = gql`
    query ReadSenderRecipients($search: String) {
  senderRecipients(filter: {name: {REGEX: $search, OPTIONS: "i"}}, sort: {name: ASC}) {
    _id
    _deleted
    supplierNumber
    countryCode
    name
    place
    postCode
    street
    phone
    inactive
  }
}
    `;

    export function useReadSenderRecipientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadSenderRecipientsQuery, ReadSenderRecipientsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadSenderRecipientsQuery, ReadSenderRecipientsQueryVariables>(ReadSenderRecipientsDocument, baseOptions);
    };
      export function useReadSenderRecipientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadSenderRecipientsQuery, ReadSenderRecipientsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadSenderRecipientsQuery, ReadSenderRecipientsQueryVariables>(ReadSenderRecipientsDocument, baseOptions);
      };
      
export type ReadSenderRecipientsQueryHookResult = ReturnType<typeof useReadSenderRecipientsQuery>;
export type ReadSenderRecipientsQueryResult = ApolloReactCommon.QueryResult<ReadSenderRecipientsQuery, ReadSenderRecipientsQueryVariables>;
export const CreateSenderRecipientDocument = gql`
    mutation CreateSenderRecipient($input: SenderRecipientInsertType) {
  createSenderRecipient(input: $input) {
    _id
  }
}
    `;
export type CreateSenderRecipientMutationFn = ApolloReactCommon.MutationFunction<CreateSenderRecipientMutation, CreateSenderRecipientMutationVariables>;

    export function useCreateSenderRecipientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSenderRecipientMutation, CreateSenderRecipientMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateSenderRecipientMutation, CreateSenderRecipientMutationVariables>(CreateSenderRecipientDocument, baseOptions);
    };
export type CreateSenderRecipientMutationHookResult = ReturnType<typeof useCreateSenderRecipientMutation>;
export type CreateSenderRecipientMutationResult = ApolloReactCommon.MutationResult<CreateSenderRecipientMutation>;
export type CreateSenderRecipientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSenderRecipientMutation, CreateSenderRecipientMutationVariables>;
export const UpdateSenderRecipientDocument = gql`
    mutation UpdateSenderRecipient($id: ID, $update: SenderRecipientSetType) {
  updateSenderRecipient(filter: {_id: {EQ: $id}}, update: {set: $update}) {
    _id
  }
}
    `;
export type UpdateSenderRecipientMutationFn = ApolloReactCommon.MutationFunction<UpdateSenderRecipientMutation, UpdateSenderRecipientMutationVariables>;

    export function useUpdateSenderRecipientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSenderRecipientMutation, UpdateSenderRecipientMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateSenderRecipientMutation, UpdateSenderRecipientMutationVariables>(UpdateSenderRecipientDocument, baseOptions);
    };
export type UpdateSenderRecipientMutationHookResult = ReturnType<typeof useUpdateSenderRecipientMutation>;
export type UpdateSenderRecipientMutationResult = ApolloReactCommon.MutationResult<UpdateSenderRecipientMutation>;
export type UpdateSenderRecipientMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSenderRecipientMutation, UpdateSenderRecipientMutationVariables>;
export const DeleteSenderRecipientDocument = gql`
    mutation DeleteSenderRecipient($ids: [ID!]!) {
  deleteSenderRecipient(filter: {_id: {IN: $ids}}) {
    _deleted
  }
}
    `;
export type DeleteSenderRecipientMutationFn = ApolloReactCommon.MutationFunction<DeleteSenderRecipientMutation, DeleteSenderRecipientMutationVariables>;

    export function useDeleteSenderRecipientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSenderRecipientMutation, DeleteSenderRecipientMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteSenderRecipientMutation, DeleteSenderRecipientMutationVariables>(DeleteSenderRecipientDocument, baseOptions);
    };
export type DeleteSenderRecipientMutationHookResult = ReturnType<typeof useDeleteSenderRecipientMutation>;
export type DeleteSenderRecipientMutationResult = ApolloReactCommon.MutationResult<DeleteSenderRecipientMutation>;
export type DeleteSenderRecipientMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSenderRecipientMutation, DeleteSenderRecipientMutationVariables>;